const loaderText = [
  'Creating your profile...',
  'Setting up your preferences...',
  'Personalizing your feed...',
  'Ready for your non-judgmental AI experience?',
];

export const getLoaderText = (frame: number): string => {
  if (frame > 225) {
    return loaderText[3];
  }
  if (frame > 150) {
    return loaderText[2];
  }

  if (frame > 80) {
    return loaderText[1];
  }

  return loaderText[0];
};
